import A11yDialog from 'a11y-dialog';
import { BODY } from './_global-variables.js';

// Setting up the modal - add your selectors here
const modalSelectors = ['.c-profile__cover-link'];
const modalElements = document.querySelectorAll(modalSelectors.join(', '));

const modalIds = [];

modalElements.forEach(function (el) {
  const id = el.getAttribute('data-a11y-dialog-show');
  if (id) {
    modalIds.push(id);
  }
});

if (modalIds.length > 0) {
  modalIds.forEach(function (id) {
    const modalContainer = document.getElementById(id);
    if (!modalContainer) return;

    const modal = new A11yDialog(modalContainer);

    modal.on('show', function () {
      // Store the current scroll position in a CSS variable
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      BODY.style.setProperty('--scroll-y', `${scrollY}px`);
      BODY.classList.add('modal--open');
    });

    modal.on('hide', function () {
      // Restore the scroll position
      const scrollY = parseInt(BODY.style.getPropertyValue('--scroll-y') || '0');
      BODY.classList.remove('modal--open');
      window.scrollTo(0, scrollY); // Restore the scroll position
    });
  });
}